// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-share-link--twitter[data-v-2ae0d804]{background-image:url(/assets-proxy/images/sns/sns-twitter.svg)}", ""]);
// Exports
module.exports = exports;
